/** @jsxImportSource @emotion/react */
import { Table } from "../../../../components/table-components/Table";
import { colors } from "../../../../components/colors";
import { TableRow } from "../../../../components/table-components/TableRow";
import { TableBody } from "../../../../components/table-components/TableBody";
import { TableRowHeader } from "../../../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../../../components/table-components/TableCellHeaderText";
import { StyledText } from "../../../../assets/typography/typography";
import { AdyenAccountHolderPaymentInstrument } from "../../models/adyen-account-holder-payment-instrument";
import { TableCellText } from "../../../../components/table-components/TableCellText";

type Props = {
  paymentInstruments: AdyenAccountHolderPaymentInstrument[];
};

export const AdyenAccountHolderPaymentInstsrumentsTable = ({
  paymentInstruments,
}: Props) => {
  return (
    <Table>
      <thead>
        <TableRowHeader>
          <TableCellHeaderText>Reference</TableCellHeaderText>
          <TableCellHeaderText>Real last 4</TableCellHeaderText>
          <TableCellHeaderText>Trusted source</TableCellHeaderText>
        </TableRowHeader>
      </thead>
      <TableBody>
        {paymentInstruments.map((paymentInstrument, i) => {
          return (
            <TableRow key={i}>
              <TableCellText className="pl-5">
                <StyledText
                  className="bodyTextRegular mb-0"
                  color={colors.textPrimary}
                >
                  {paymentInstrument.reference || "-"}
                </StyledText>
              </TableCellText>
              <TableCellText>
                <StyledText
                  className="bodyTextRegular mb-0"
                  color={colors.textPrimary}
                >
                  {paymentInstrument.realLastFour || "-"}
                </StyledText>
              </TableCellText>
              <TableCellText>
                <StyledText
                  className="bodyTextRegular mb-0"
                  color={colors.textPrimary}
                >
                  {paymentInstrument.trustedSource || "-"}
                </StyledText>
              </TableCellText>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
